// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// ============================================
// 1文字ずつ表示
// ============================================
function splitTxt() {
  //対象要素を複数取得
  const textWraps = document.querySelectorAll('.js-split-text');

  if (textWraps.length > 0) {
    textWraps.forEach((textWrap) => {
      const textIns = textWrap.querySelectorAll('.js-split-text__in');

      textIns.forEach((textIn) => {
        // 文字をspanで囲む作業
        // ==========================================
        if (textIn.classList.contains('-hasChild')) {
          //以下、下線をひくとき
          const textChild = textIn.querySelector('.c-text-line01'); //下線用のspanを一つだけ取得

          //読み上げ対策
          const textCont = textChild.textContent; //中身の文字を取得
          textChild.setAttribute('aria-label', textCont);

          // 文字を一文字ずつ囲う
          const spannedText = Array.from(textCont)
            .map((char) => `<span class="js-split-text__in-char" aria-hidden="true">${char}</span>`)
            .join('');

          textChild.innerHTML = spannedText;
        } else {
          //以下、下線をひかないとき

          //読み上げ対策
          const textCont = textIn.textContent; //中身の文字を取得
          textIn.setAttribute('aria-label', textCont);

          // 文字を一文字ずつ囲う
          const spannedText = Array.from(textCont)
            .map((char) => `<span class="js-split-text__in-char" aria-hidden="true">${char}</span>`)
            .join('');

          textIn.innerHTML = spannedText;

        }

				if (textWrap.classList.contains('-js-scroll')) {
					gsap.utils.toArray('.js-split-text').forEach((target) => {
						gsap.to(target, {
							scrollTrigger: {
								trigger: target,
								start: () => 'top 75%',
								toggleClass: {
									targets: target,
									className: 'is-active',
								},
								once: true,
							},
						});
					});
				}

        // 文字に対してアニメーションをつける
        // ==========================================
        const charAry = textWrap.querySelectorAll('.js-split-text__in-char');
        for (let index = 0; index < charAry.length; index++) {
          Object.assign(charAry[index].style, {
            opacity: 0,
            animationDelay: index * 0.02 + 's',
          });
        }
      });
    });
  }
}

// ============================================
// export
// ============================================
export { splitTxt };
